<template>
  <div class="c-map-modal c-map-modal--search" v-if="showModal">
    <div class="c-map-modal__shadow" v-on:click="closeButtonClickHandler"></div>
    <div
      class="c-map-modal__body"
      role="dialog"
      v-bind:aria-labelledby="'modalTitle' + _uid"
      aria-modal="true"
    >
      <MapSearch
        v-bind:map="map"
        v-bind:config="config"
        v-on:searchLocation="searchLocation"
        v-bind:id="id"
      />
    </div>
  </div>
</template>

<script>
import MapSearch from "./MapSearch";

export default {
  name: "MapSearchModal",
  components: {
    MapSearch,
  },
  props: ["config","id", "map", "modalContent", "showModal"],
  data() {
    return {
      icon: null,
      layer: null,
      location: null,
    };
  },
  methods: {
    searchLocation() {
      this.$emit("searchLocation");
    },
    closeButtonClickHandler() {
      this.$emit("modalClose");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/layered-map/MapSearchModal.vue